export default (function (value) {
  return value === null;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isNull.js
// module id = ./node_modules/redux-actions/es/utils/isNull.js
// module chunks = 6 9 11